// extracted by mini-css-extract-plugin
module.exports = {"component":"MultiSelectOptions-component--3j-vw"};